/* See It On Your Wall: auto-trigger the tool's own "Load more" as you scroll.

   That page already has a working Load more button, it just needs a tap. This
   makes it behave like the collection grid and the pack picker so no screen in
   the shop stops at a page boundary.

   Deliberately conservative: it only clicks a button that is visible, enabled,
   and near the viewport, never faster than once a second, and it gives up
   after two clicks that produce no new tiles. */
(function(){
  'use strict';

  function findBtn(){
    var all=document.querySelectorAll('button, a');
    for(var i=0;i<all.length;i++){
      var b=all[i];
      if(b.disabled)continue;
      if(b.offsetParent===null)continue;               /* hidden */
      var t=(b.textContent||'').trim().toLowerCase();
      if(t==='load more'||t==='show more'||t==='load more posters')return b;
    }
    return null;
  }

  function tiles(){ return document.querySelectorAll('.wp-tile').length; }

  function start(){
    if(document.documentElement.dataset.cbAutoload)return;
    if(!document.querySelector('[data-grid]'))return;   /* wall tool only */
    document.documentElement.dataset.cbAutoload='1';

    var last=0, stale=0, busy=false;

    function tick(){
      if(busy)return;
      var b=findBtn();
      if(!b)return;

      var r=b.getBoundingClientRect();
      if(r.top > (window.innerHeight||0)+600)return;    /* not near yet */

      var before=tiles();
      busy=true;
      b.click();

      setTimeout(function(){
        var after=tiles();
        if(after<=before){
          stale++;
          if(stale>=2){ document.documentElement.dataset.cbAutoload='stopped'; }
        }else{
          stale=0;
        }
        busy=false;
      },1100);
    }

    var t=0;
    function onScroll(){
      if(document.documentElement.dataset.cbAutoload==='stopped')return;
      if(t)return;
      t=setTimeout(function(){ t=0; tick(); },180);
    }

    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll,{passive:true});

    /* Also watch the tool's own scroll container, if it has one. */
    var grid=document.querySelector('[data-grid]');
    if(grid&&grid.parentElement)grid.parentElement.addEventListener('scroll',onScroll,{passive:true});
    if(grid)grid.addEventListener('scroll',onScroll,{passive:true});

    onScroll();
  }

  function boot(){ try{ start(); }catch(e){} }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',function(){ setTimeout(boot,300); });
  setTimeout(boot,1500);   /* the tool renders its grid after its own fetch */
})();
